module.exports = __webpack_public_path__ + "static/media/MSMEBen7.c7a1ac20.svg";